import { DataGridFilters } from "fe-shared/src/components/DataGrid/modules/types";
import { parseQuery } from "fe-shared-transactions/src/helpers/queryString";

interface FilterQuery {
  from: string;
  to: string;
  participantRegNumber: string;
  adjustmentNumber: string;
}

export const getInventoryAdjustmentFilterParams = (
  search: string
): DataGridFilters => {
  const parsedQuery = parseQuery(search) as Partial<FilterQuery>;
  const { from, to, adjustmentNumber, participantRegNumber } = parsedQuery;

  return {
    ...(from && to
      ? {
          completedDate: {
            type: "dateRangeFilter",
            value: [from, to],
          },
        }
      : {}),
    ...(adjustmentNumber
      ? {
          adjustmentNumber: {
            type: "textFilter",
            value: adjustmentNumber,
          },
        }
      : {}),
    ...(participantRegNumber
      ? {
          displayNameOrRegNumber: {
            type: "textFilter",
            value: participantRegNumber,
          },
        }
      : {}),
  };
};

export default {
  getInventoryAdjustmentFilterParams,
};
